export default function BasketFixedUrl($q, $location, $routeParams, Error) {
    var fn = this;

    /**
     * What this will do
     *
     * Load search from url
     */

    fn.init = function () {
        /**
         * get from url
         */

        const urlParams = fn.getParamsFromUrl();

        /**
         * feature : check date and time
         * Work in progress
         */
        // UrlFactory.checkDateTime(urlParams); //if url date/time is in the past?

        /**
         * async - request collection of items frm API ($q all)
         */
        return fn
            .getCollection(
                urlParams.locationId,
                urlParams.start,
                urlParams.weeks,
                urlParams.activityId,
                urlParams.resourceId,
                urlParams.isFixed,
                urlParams.startTime,
                urlParams.endTime
            )
            .then(function (res) {
                /**
                 * set as null if error from API
                 * None found or non given
                 *
                 * */

                const collection = {
                    locationId:
                        res.locationId instanceof Error ? null : res.locationId,
                    start: res.start instanceof Error ? null : res.start,
                    weeks: res.weeks instanceof Error ? null : res.weeks,
                    activityId:
                        res.activityId instanceof Error ? null : res.activityId,
                    resourceId:
                        res.resourceId instanceof Error ? null : res.resourceId,
                    isFixed: res.isFixed instanceof Error ? false : res.isFixed,
                    startTime:
                        res.startTime instanceof Error ? null : res.startTime,
                    endTime: res.endTime instanceof Error ? null : res.endTime,
                };

                /**
                 * Update the SearchBar
                 */

                // setSearchFilterService
                // UrlFactory.setSearchFilterService(
                //     collection.activity,
                //     collection.location,
                //     collection.date,
                //     collection.start,
                //     collection.end,
                //     collection.hours,
                //     collection.weeks
                // );

                /**
                 * switch to searchbar format
                 */

                // searchBarFactory.updateSearchBar(
                //     collection.activity,
                //     collection.location,
                //     collection.date,
                //     collection.start,
                //     collection.end,
                //     collection.hours
                // );

                /**
                 * Trigger a Search
                 */
                let setRoute = false; // deafult true
                // searchBarFactory.searchBroadcast(setRoute);

                // Basket.setSearchPeriodsUrl($location.$$url);

                return $q.resolve(collection);
            });
    };

    /**
     * GET FROM ROUTE, SEARCH ->
     */

    fn.getParamsFromUrl = function () {
        // let decoded = decodeURI(encoded);

        return {
            locationId: parseInt($routeParams.locationId)
                ? parseInt($routeParams.locationId)
                : null,

            start: $routeParams.start ? $routeParams.start : null,
            weeks: $routeParams.weeks ? parseInt($routeParams.weeks) : null,
            activityId: parseInt($routeParams.activityId)
                ? parseInt($routeParams.activityId)
                : null,
            resourceId: $routeParams.resourceId
                ? parseInt($routeParams.resourceId)
                : null,
            isFixed: $routeParams.isFixed,
            startTime: $routeParams.startTime ? $routeParams.startTime : null,
            endTime: $routeParams.endTime ? $routeParams.endTime : null,
        };
    };

    /**
     * refactor to HouseService / other factory ?
     */
    fn.getCollection = function (
        locationId,
        start,
        weeks,
        activityId,
        resourceId,
        isFixed,
        startTime,
        endTime
    ) {
        // We can just return a value without creating a promise if we don't need.
        // const date = date;
        // const start = start;
        // const end = end;
        // const hours = hours;

        return $q
            .all({
                locationId: locationId,
                start: start,
                weeks: weeks,
                activityId: activityId,
                resourceId: resourceId,
                isFixed: isFixed,
                startTime: startTime,
                endTime: endTime,
            })
            .then(function (collection) {
                return collection;
            });
    };

    /**
     * APPLY ROUTE ->
     * VOID
     */

    fn.setRoute = function (
        locationId,
        start,
        weeks,
        activityId,
        resourceId,
        isFixed,
        startTime,
        endTime
    ) {
        /**
         * Construct the path
         */

        // fn.prettifyParam(
        //     fn.constructPath(activity, location, hasWeeks).toLowerCase()
        // );
        /**
         * add other params as query ( ?date={date}&start={start}...etc.... )
         */
        $location.path("/basket-fixed/").search({
            locationId: fn.prettifyParam(locationId),
            start: fn.prettifyParam(start),
            weeks: fn.prettifyParam(weeks),
            activityId: fn.prettifyParam(activityId),
            resourceId: fn.prettifyParam(resourceId),
            isFixed: fn.prettifyParam(isFixed),
            startTime: fn.prettifyParam(startTime),
            endTime: fn.prettifyParam(endTime),
        });
    };

    /**
     * Convert
     * spaces = -
     * æ = ae
     * ø = oe
     * å = aa
     */
    fn.prettifyParam = function (param) {
        return param;
        // console.log
        // return latinize(str);
    };

    // fn.init();

    return fn;
}
